/**
 * Returns true for any host where PostHog's automated-browser filter and
 * session recording must be relaxed: staging (preview), local dev, and CI.
 * Production is the only host that holds real founder data and must keep the
 * SDK's default bot filter enabled.
 *
 * Callers that run in the browser MUST pass explicit property reads, not
 * `process.env` itself — Next.js only inlines NEXT_PUBLIC_* and NODE_ENV when
 * accessed as literal `process.env.X` reads; passing the object as a whole
 * produces an empty object in the browser bundle (LEV-1693).
 */
export function isNonProductionAnalyticsHost(env: {
  NODE_ENV?: string;
  NEXT_PUBLIC_VERCEL_ENV?: string;
}): boolean {
  return (
    env.NODE_ENV === "development" || env.NEXT_PUBLIC_VERCEL_ENV === "preview"
  );
}

/**
 * The host every PostHog caller falls back to when NEXT_PUBLIC_POSTHOG_HOST is
 * unset. Capture and query clients MUST resolve to the same region, or events
 * land in one project while queries read another.
 */
export const POSTHOG_DEFAULT_HOST = "https://us.i.posthog.com";
